import InformationButton from "../../../components/molecules/InformationButton"
import PartitaIvaTootltipDescription from "../../../components/molecules/PartitaIvaTootltipDescription"
import { getCountryFromLanguage } from "../../../core/service/BusinessLogicService"
import { loc } from "../../../core/utils"
import Date from "../../../form/Date"
import Select from "../../../form/Select"
import TextField from "../../../form/TextField"
import { DATE_FORMAT, contractTypeEnum } from "../constants/ClientPageConstants"
import { ItalianIncomeNumberField } from "./IT"
import React from "react"
import { Col } from "react-bootstrap"

export default function SmallBusinessFields(props) {
  const { values, tunnelData, country, clientPageConfiguration } = props
  const { situation } = clientPageConfiguration

  return (
    <>
      {situation?.includes("workingSituation") && (
        <Col lg={6}>
          <Select
            name="situation.workingSituation"
            label={loc`Contract type`}
            url={
              tunnelData.apiUrl +
              "middle-business-service/api/v2/repository/working-situation/" +
              getCountryFromLanguage(tunnelData.data.order.orderLanguageTag)
            }
            token={tunnelData.access_token}
          />
        </Col>
      )}
      {values?.situation?.workingSituation?.value === contractTypeEnum && situation?.includes("endContractDate") && (
        <Col lg={6}>
          <Date
            name="situation.endContractDate"
            label={loc`endContractDate`}
            format={DATE_FORMAT.situation.endContractDate[country]}
            disabled={
              tunnelData.data.order.simplifiedJourneyEnabled &&
              !tunnelData?.simplifiedJourneyInputConfiguration?.situation?.endContractDate?.editable
            }
          />
        </Col>
      )}
      <Col lg={6} style={{ paddingRight: 0 }}>
        <TextField name="situation.vatBusinessCode" label={loc`VatBusinessCode`} trimOnBlur={true}>
          <InformationButton
            overlayText={loc("partitaIvaTooltipDescription", {
              description: <PartitaIvaTootltipDescription />
            })}
          />
        </TextField>
      </Col>
      <Col lg={6}>
        <ItalianIncomeNumberField
          isDisabled={
            tunnelData.data.order.simplifiedJourneyEnabled &&
            !tunnelData?.simplifiedJourneyInputConfiguration?.situation?.netMonthlyIncome.editable
          }
        />
      </Col>
    </>
  )
}
